var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AntButton',_vm._g(_vm._b({class:( _obj = {}, _obj[_vm.customClass] = !!_vm.customClass, _obj['ant-btn--simple'] =  _vm.simple, _obj ),attrs:{"block":_vm.fullWidth}},'AntButton',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }